export default {
      id: "slide-button-noactive-usage",
      viewBox: "0 0 40 40",
      url: __webpack_public_path__ + "img/icons.79e00d12.svg#slide-button-noactive",
      toString: function () {
        return this.url;
      }
    }